<script>
import { EventBus } from "../../../event-bus.js";
import { computed } from 'vue'

export default {
  name: "MenuHeaderMenu",
  setup(){
    const isPro = computed(() => {
      return window.location.pathname.includes("/pro")
    })

    const isPrescripteur = computed(() => {
      return window.location.pathname.includes("/prescripteur")
    })

    function toggleMenu() {
        EventBus.$emit("toggleAccountMenu");
    }

    return { toggleMenu, isPrescripteur, isPro}
  }
}

</script>

<style lang="sass">
@import ../../../common/styles/settings
@import MenuHeaderMenu
</style>

